import React, { Component } from 'react';
import { connect } from 'dva';
import moment from 'moment';
import { stringify } from 'qs';
import SelectUser from 'nbugs-select-user-result-v4.0'
import { Badge, Tooltip, Col, Row, Input, Form, Button, DatePicker, Modal } from 'antd';
import router from 'umi/router';
import Container from '../../../../../components/Container';
import ListPage from '../../../../../components/ListPage';
import { getAppCode } from '../../utils/utils';
import { getPathHeader } from '../../../../../utils/utils';
import styles from './index.less';

const { ListTable } = ListPage;
const { RangePicker } = DatePicker;

@connect()
class SyncHronousRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      dataSource: [],
      loading: false,
      totalElements: 0,
      params: {
        appCode: getAppCode(),
        page: 1,
        pageSize: 10,
        title: '',
        start_time: '',
        end_time: '',
      },
      isModalVisible: false,
      selectId: ''
    };
  }

  componentDidMount() {
    const { params } = this.state;
    this.setColumns();
    this.fetchDownRecord(params);
  }

  search = e => {
    e.preventDefault();
    const { form } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { params } = this.state;
        const rangeValue = values['range-picker'];
        const tempParams = {
          ...params,
          title: values.title ? encodeURIComponent(values.title) : '',
          start_time: rangeValue && rangeValue[0] ? rangeValue[0].format('YYYYMMDD') : '',
          end_time: rangeValue && rangeValue[1] ? rangeValue[1].format('YYYYMMDD') : '',
          page: 1,
        };
        this.setState({
          params: tempParams,
        });
        this.fetchDownRecord(tempParams);
      }
    });
  };

  reSet = () => {
    const { form } = this.props;
    form.resetFields();
    const { params } = this.state;
    const tempParams = {
      ...params,
      title: '',
      start_time: '',
      end_timg: '',
      page: 1,
    };
    this.setState({
      params: tempParams,
    });
    this.fetchDownRecord(tempParams);
  };

  fetchDownRecord = params => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'synchronous/fetchDownRecord',
      params,
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: res.content,
          totalElements: res.totalElements,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  // 跳转详情
  handleGoToDetail = (id, record) => {
    router.push(
      `/${getPathHeader()}/operateRecord/allSync/approvalDetail?id=${
        record.newsId
      }&appCode=${getAppCode()}`
    );
  };

  setColumns = () => {
    const columns = [
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        render: text => {
          if (text.length <= 20) {
            return <span>{text}</span>;
          }
          return (
            <Tooltip placement="top" title={text}>
              <span>{text.substring(0, 20)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '同步对象',
        dataIndex: 'downType',
        key: 'downType',
        render: (text, record) => {
          const textType = {
            1: '同步下属学校',
          };
          if (record.selectId) {
            return <div style={{ color: '#1785EC' }} onClick={e => {
              e.stopPropagation();
              this.setState({
                isModalVisible: true,
                selectId:record.selectId
              })
            }}>查看</div>
          }
          return <span>{textType[text]}</span>;
        },
      },
      {
        title: '操作人',
        dataIndex: 'downUserName',
        key: 'downUserName',
        render: text => {
          return <span>{text || '-'}</span>;
        },
      },
      {
        title: '同步时间',
        dataIndex: 'downTime',
        key: 'downTime',
        width: 160,
        render: text => {
          return <span>{moment(text).format('YYYY.MM.DD HH:mm')}</span>;
        },
      },
    ];
    this.setState({ columns });
  };

  changePage = (page, pageSize) => {
    const { params } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    this.setState({ params: tempParams });
    this.fetchDownRecord(tempParams);
  };

  render() {
    const { columns, loading, dataSource, params, totalElements, isModalVisible, selectId } = this.state;
    const { page } = params;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };
    const { form } = this.props;
    const { getFieldDecorator } = form;
    const pageProps = {
      spinProps: { spinning: loading },
      className: styles.root,
    };

    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      onItemClick: this.handleGoToDetail,
      onPageChange: this.changePage,
    };

    const selectUserProps = {
      multiple: true,
      selectType: "dept",
      strictOrgRel: true,
      showTabList: ['orgRel'],
      selectSignature: selectId,
      isSaveSelectSignature: true,
      requestParams: {
        strictUser: true,
        selectTypeList: ['org_rel'],
      },
      resultTitle: '发布对象',
    };

    return (
      <Container breStates={!0} version={2}>
        <ListPage {...pageProps}>
          <Row className={styles['search-area']}>
            <Col span={10}>
              <Form.Item {...formItemLayout} label="文章标题">
                {getFieldDecorator('title', {
                  rules: [
                    {
                      max: 50,
                      message: '请勿超过50个字!',
                    },
                  ],
                })(<Input placeholder="请输入标题" onPressEnter={this.search} />)}
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item label="同步时间" {...formItemLayout}>
                {getFieldDecorator(
                  `range-picker`,
                  {}
                )(<RangePicker format="YYYY-MM-DD" placeholder={['请选择', '请选择']} />)}
              </Form.Item>
            </Col>
            <Col offset={20} style={{ textAlign: 'right' }}>
              <Form.Item>
                <Button type="primary" onClick={this.search}>
                  查询
                </Button>
                <Button onClick={this.reSet}>重置</Button>
              </Form.Item>
            </Col>
          </Row>
          <section className="table-area">
            <ListTable {...tableProps} />
          </section>
        </ListPage>

        <Modal centered title="查看同步对象" wrapClassName='select-user-result-v4-modal' visible={isModalVisible} onOk={() => {
          this.setState({
            isModalVisible: false,
            selectId: ''
          })
        }} onCancel={() => {
          this.setState({
            isModalVisible: false,
            selectId: ''
          })
        }}>
          <SelectUser selectUserProps={selectUserProps} />
        </Modal>
      </Container>
    );
  }
}
const SynchronousRecord = Form.create()(SyncHronousRecord);
export default SynchronousRecord;
